module.exports = __webpack_public_path__ + "img/window.be5030ca.webp";